import React, { useState } from "react";
import FooterThree from "../../common/Footer/FooterThree";
import Menu from "../../common/Menu/Menu";
import ProductsBanner from "./ProductsBanner";
import ProductsItems from "./ProductsItems";
import ElevatorLoader from "../../Loder/ElevatorLoader";



const Products = () => {
  
const [loading, setLoading] = useState(true);
  return (
    <div>
      {loading && <ElevatorLoader onFinish={() => setLoading(false)} />}
      <Menu header_style_2={true} />
      <ProductsBanner />
      <ProductsItems />
      <FooterThree />
    </div>
  );
};

export default Products;
